import SpeakersTableFieldArray from './SpeakersTableFieldArray';

export default SpeakersTableFieldArray;
